import { Placeholder } from '../Placeholder/Placeholder';

export const ArticleEditorTitleInputLoader = () => <Placeholder className="h-[34px] md:h-[90px] w-3/4 rounded-md" />;
